"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestGiver = void 0;
const definables_1 = require("definables");
class QuestGiver extends definables_1.Definable {
    constructor(options) {
        super(options.id);
        this._quests = [];
        this._quests = options.definition.questGiverQuests.map((questGiverQuest) => ({
            questID: questGiverQuest.questID,
        }));
    }
    get quests() {
        return this._quests;
    }
}
exports.QuestGiver = QuestGiver;
